import type { CurrentThemesResponse } from '@apis/_themes'
import { INVOICE_TOUR_NAME_FOR_INVOICE } from '../config/tourTargetCatalog'

export const pickInvoiceThemeIdFromCurrentThemes = (
  data?: CurrentThemesResponse | null,
): string | null => {
  const invoiceTheme =
    data?.items?.find((theme) => theme.name === INVOICE_TOUR_NAME_FOR_INVOICE) ??
    data?.items?.find((theme) => theme.type_code === 'invoice')

  return invoiceTheme?.id != null ? String(invoiceTheme.id) : null
}
